import config from '../../../config'
import http from './http-util'
import { buildSortParams } from '../util/helpers'

const SORT_PARAMS = buildSortParams([
  ['publicationStart', 'desc'],
  ['created', 'desc'],
])

class NewsServiceApi {
  static getUserArticles = token => {
    return http.get(
      token,
      `${config.newsServiceUrl}/public/articles?${SORT_PARAMS}`,
    )
  }

  static articleAcknowledgement = (articleId, token) => {
    return http.put(
      token,
      `${config.newsServiceUrl}/public/articles/${articleId}/acknowledgement`,
      JSON.stringify({ data: 'Read' }),
    )
  }

  static getFilteredAdminArticles =
    (body, { page, size }) =>
    token => {
      return http.post(
        token,
        `${config.newsServiceUrl}/admin/articles/search?${SORT_PARAMS}&page=${page}&size=${size}`,
        JSON.stringify(body),
      )
    }

  static getArticle = (articleId, token) => {
    return http.get(
      token,
      `${config.newsServiceUrl}/admin/articles/${articleId}`,
    )
  }

  static saveArticle = (body, token) => {
    return http.post(token, `${config.newsServiceUrl}/admin/articles`, body)
  }

  static deleteArticle = (articleId, token) => {
    return http.delete(
      token,
      `${config.newsServiceUrl}/admin/articles/${articleId}`,
    )
  }
}

export default NewsServiceApi
